import React from 'react';
import { PostHeaderProps } from '../../types';
import { LikeButton } from '../LikeButton';
import { useHeader } from './hooks';
import {
  Container,
  DateHeader,
  LikeContainer,
  Menu,
  MenuContainer,
  ShefImage,
  ShefInfo,
  ShefInfoContainer,
} from './styles';

export const Header: React.FC<PostHeaderProps> = (props) => {
  const { date, likeButtonProps, menuProps, shefImageUrl, shefName, showLikes, showMenu } = useHeader(props);

  const shefInfo = shefImageUrl ? (
    <>
      <ShefImage src={shefImageUrl} />
      <ShefInfo>
        <div>{shefName}</div>
        <DateHeader>{date}</DateHeader>
      </ShefInfo>
    </>
  ) : (
    <DateHeader>{date}</DateHeader>
  );

  return (
    <Container>
      <ShefInfoContainer>{shefInfo}</ShefInfoContainer>
      <LikeContainer>
        {showLikes && <LikeButton {...likeButtonProps} />}
        {showMenu && (
          <MenuContainer>
            <Menu {...menuProps} />
          </MenuContainer>
        )}
      </LikeContainer>
    </Container>
  );
};
